<template>
  <div class="el-test">
    <el-button type="primary" @click.native="$emit('clickEvent')">button-demo</el-button>
  </div>
</template>

<script>
export default {
  name: 'wiz-button',
  methods: {
    handleClick() {
      this.$emit('clickEvent')
    },
  },
}
</script>

<style lang="scss" scoped>
.el-test {
  ::v-deep .el-button--primary {
    background: yellow;
  }
}
</style>
